import React from "react";
import * as Styled from "./styles.module";

import TechniciansContactsList from "../TechniciansContactsList/TechniciansContactsList.Container";
import CustomersContactsList from "../CustomersContactsList/CustomersContactsList.Container";

import { Button } from "../../../components/UIKitComponents/Button/Button";
import { Icon } from "../../../components/UIKitComponents/Icon/Icon";

import { ContactTypes } from "../../constants";

interface ISideBarProps {
  activeTab: number;
  customerMsgCounter: any;
  technicianMsgCounter: any;
  hasAccessToWorkspaces: boolean;
  setActiveTab: (contactsType: number) => void;
  backToDashboard: () => void;
  toggleSenderListShown: () => void;
  toggleWorkspaceListShown: () => void;
}

type Props = ISideBarProps;

export class SideBar extends React.Component<Props> {
  render() {
    const activeTab = this.props.activeTab;

    return (
      <Styled.SideBarStyles>
        {/* <Button
          className="typo typo-text-14 communication-sidebar__btn-back --up"
          onSubmit={() => this.props.backToDashboard()}
          size="small"
        >
          <Icon
            icon="backward"
            color="#4a5580"
            classWrapper="communication-sidebar__btn-back-icon-wrap"
            className="communication-sidebar__btn-back-icon"
          />
          <span className="typo typo-text-14">Back to Dashboard</span>
        </Button> */}

        {/* <Styled.ChangeSenderBtn
          className="typo typo-text-14"
          onSubmit={() => this.props.toggleSenderListShown()}
          size="small"
        >
          Change Sender ID
        </Styled.ChangeSenderBtn> */}

        {this.props.hasAccessToWorkspaces ? (
          <Styled.ChangeWorkspaceBtn
            className="typo typo-text-14"
            onSubmit={() => this.props.toggleWorkspaceListShown()}
            size="small"
          >
            Check personal SMS
          </Styled.ChangeWorkspaceBtn>
        ) : (
          ""
        )}

        <div className="tabs">
          <div className="tabs__items">
            <div
              className={`tabs__item typo typo-bold typo-text-14 ${activeTab === ContactTypes.CUSTOMER ? "--active" : ""}`}
              onClick={() => this.props.setActiveTab(ContactTypes.CUSTOMER)}
            >
              {this.props.customerMsgCounter > 0 ? (
                <Styled.TabMsgNotifier />
              ) : (
                ""
              )}
              Customers
            </div>
            <div
              className={`tabs__item typo typo-bold typo-text-14 ${activeTab === ContactTypes.TECHNICIAN ? "--active" : ""}`}
              onClick={() => this.props.setActiveTab(ContactTypes.TECHNICIAN)}
            >
              {this.props.technicianMsgCounter > 0 ? (
                <Styled.TabMsgNotifier />
              ) : (
                ""
              )}
              Technicians
            </div>
          </div>

          <div
            className={`tabs__content ${activeTab === ContactTypes.CUSTOMER ? "--active" : ""}`}
          >
            <CustomersContactsList />
          </div>
          <div
            className={`tabs__content ${activeTab === ContactTypes.TECHNICIAN ? "--active" : ""}`}
          >
            <TechniciansContactsList />
          </div>
        </div>
      </Styled.SideBarStyles>
    );
  }
}
